import React from 'react';

// import { Container } from './styles';

const Users: React.FC = () => {
    return (
        <h1>Users</h1>
    );
}

export default Users;